import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class WaterParametersModel extends BaseModel {

    constructor() {
        super({
            name: "water_parameters",
            tableName: 'water_parameters',
            label: "Cài đặt thông số nước",
            display_key: 'name',
            default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name',
                type: "String",
                class: "center",
                label: 'Tên thông số',
                sortable: false,
                filter: {
                    type: 'input',
                    match: 'contains'
                },
            },
            code: {
                name: 'code',
                display: false
            },
            value: {
                name: 'value',
                type: "String",
                class: "center",
                label: 'Giá trị thông số',
                computed: (data) => {
                    data.value = "";
                }
            },
            warning_value: {
                name: 'warning_value',
                type: "String",
                class: "center",
                label: 'Giá trị cảnh báo',
                computed: (data) => {
                    data.warning_value = "";
                }
            },
            active: {
                name: "active",
                type: "Selection", 
                custom: 'SelectionText',
                label: "Trạng thái",
                class: "center",
                options: [
                    {value : true , label: "Hoạt động"},
                    {value : false , label : "Không hoạt động"}
                ],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            water_parameters_values: {
                refs: 'water_parameters_values {id value obtain unobtain active ordinal created_at}',
                display: false
            },
            },
        )
    }

}